import { MapTo } from '@adobe/aem-react-editable-components';
import ArticleRichtext, { ArticleRichtextEditConfig } from './ArticleRichtext';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/article-richtext',
)(ArticleRichtext, ArticleRichtextEditConfig);